import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "category/politics-and-society",
  "use": "category/politics-and-society-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"category/politics-and-society\"><path d=\"M24 9.28V5.86L12 0 0 5.86v3.42h2.63v9.13L0 20.68V24h24v-3.34l-2.85-2.26V9.28zM1.5 7.78v-1L12 1.67 22.5 6.8v1h-21zM9.9 18H6.83V9.28H9.9zm1.5-8.73h1.2V18h-1.2zm2.7 0H17V18h-2.9zm-8.77 0V18h-1.2V9.28zM22.5 22.5h-21v-1.14l2.15-1.85h16.49l2.36 1.87zM19.65 18h-1.2V9.28h1.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol